
let WinPanelEvent = require("clover/panel/WinPanel")[2]
let ShareUtil = require("clover/utils/ShareUtil")
var PvpActivityResultPanel = xClass("PvpActivityResultPanel", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/panel_settlement2_panel_settlement.csb")
})

PvpActivityResultPanel.show = function (pvplogic, data, isFromStandingPanel = false) {
    var panel = PvpActivityResultPanel.create(pvplogic, data, isFromStandingPanel);
    panel.popup(true);

    return panel;
}

PvpActivityResultPanel.prototype.ctor = function (pvplogic, data, isFromStandingPanel) {
    var self = this;
    BasePanel.prototype.ctor.call(self);

    cc.log("PvpActivityResultPanel", data);

    var greenColor = cc.c3b(0, 204, 51);
    var normalColor = cc.c3b(154, 70, 30);

    if (pvplogic){
        self.logic = pvplogic;
        self.logic.clearHeart();
    }

    var selfTargetFinish = data.self.targetFinish;
    var selfTargetTotal = data.self.targetTotal;
    var selfScore = data.self.score;
    var selfTime = data.self.time;
    if (selfTime > 300){
        selfTime = 300;
    }
    var selfResult = data.self.result;
    var enemyResult = data.enemy.result;
    var enemyTargetFinish = data.enemy.targetFinish;
    var enemyTargetTotal = data.enemy.targetTotal;
    var enemyScore = data.enemy.score;
    var enemyTime = data.enemy.time;
    var enemyAvatar = data.enemy.avatar;
    if (selfResult == 4 || selfResult == 6){
        // 6对方断线后直接流局的，4是只有在战报里会有
        enemyTargetFinish = "???";
        enemyScore = "???";
        enemyTime = "超时";
    }

    var player1 = self.getChildByName("player1");
    var txt1 = getText("pvp.settlement.content.goal").replace("{goal}", selfTargetFinish+"/"+selfTargetTotal);
    var player1Label1 = player1.getChildByName("txt1");
    player1Label1.width += 20;
    player1Label1.setString(txt1);
    player1Label1.setOpacity(0);
    var txt2 = getText("pvp.settlement.content.score").replace("{score}", selfScore);
    var player1Label2 = player1.getChildByName("txt2");
    player1Label2.setString(txt2);
    player1Label2.setOpacity(0);
    var txt3 = getText("pvp.settlement.content.time").replace("{time}", selfTime);
    var player1Label3 = player1.getChildByName("txt3");
    player1Label3.setString(txt3);
    player1Label3.setOpacity(0);
    player1Label3.setTextColor(cc.c3b(154, 70, 30));
    var player1Label4 = player1.getChildByName("txt4");
    player1Label4.setOpacity(0);
    var player1Icon = player1.getChildByName("icon");
    player1Icon.setOpacity(0);

    var player2 = self.getChildByName("player2");
    var txt1 = getText("pvp.settlement.content.goal").replace("{goal}", enemyTargetFinish+"/"+enemyTargetTotal);
    var player2Label1 = player2.getChildByName("txt1");
    player2Label1.width += 20;
    player2Label1.setString(txt1);
    player2Label1.setOpacity(0);
    var txt2 = getText("pvp.settlement.content.score").replace("{score}", enemyScore);
    var player2Label2 = player2.getChildByName("txt2");
    player2Label2.setString(txt2);
    player2Label2.setOpacity(0);
    var txt3 = getText("pvp.settlement.content.time").replace("{time}", enemyTime);
    if (enemyTime == "超时"){
        txt3 = txt3.replace("秒", "");
    }
    var player2Label3 = player2.getChildByName("txt3");
    player2Label3.setString(txt3);
    player2Label3.setOpacity(0);
    player2Label3.setTextColor(cc.c3b(154, 70, 30));
    var player2Label4 = player2.getChildByName("txt4");
    player2Label4.setOpacity(0);
    var player2Icon = player2.getChildByName("icon");
    player2Icon.setOpacity(0);

    var needCheckNext = true;
    if (selfResult == 5 || selfResult == 6 || enemyResult == 5 || enemyResult == 6){
        needCheckNext = false;
    }
    // 完成目标的颜色
    if (selfTargetFinish > enemyTargetFinish && selfTargetFinish >= selfTargetTotal){
        player1Label1.setTextColor(greenColor);
        player2Label1.setTextColor(normalColor);
        needCheckNext = false;
    }else if (enemyTargetFinish > selfTargetFinish && enemyTargetFinish >= enemyTargetTotal){
        player1Label1.setTextColor(normalColor);
        player2Label1.setTextColor(greenColor);
        needCheckNext = false;
    }else{
        player1Label1.setTextColor(normalColor);
        player2Label1.setTextColor(normalColor);
    }
    if (needCheckNext){
        // 积分的颜色
        if (selfScore > enemyScore){
            player1Label2.setTextColor(greenColor);
            player2Label2.setTextColor(normalColor);
            needCheckNext = false;
        }else if (enemyScore > selfScore){
            player1Label2.setTextColor(normalColor);
            player2Label2.setTextColor(greenColor);
            needCheckNext = false;
        }else{
            player1Label2.setTextColor(normalColor);
            player2Label2.setTextColor(normalColor);
        }
    }else{
        player1Label2.setTextColor(normalColor);
        player2Label2.setTextColor(normalColor);
    }
    if (needCheckNext){
        // 时间的颜色
        if (selfTime < enemyTime){
            player1Label3.setTextColor(greenColor);
            player2Label3.setTextColor(normalColor);
            needCheckNext = false;
        }else if (enemyTime < selfTime){
            player1Label3.setTextColor(normalColor);
            player2Label3.setTextColor(greenColor);
            needCheckNext = false;
        }else{
            player1Label3.setTextColor(normalColor);
            player2Label3.setTextColor(normalColor);
        }
    }else{
        player1Label3.setTextColor(normalColor);
        player2Label3.setTextColor(normalColor);
    }

    var winSp = self.getChildByName("win_signet");
    var winAction = cc.CSLoader.createTimeline("cocos/panel_settlement2_win_signet.csb");
    winSp.runAction(winAction);

    var blueHead = player1.getChildByName("frame_photo01").getChildByName("frame_photo2").getChildByName("photo");
    blueHead.setAnchorPoint(cc.p(0.5, 0.5));
    blueHead.x += 50;
    blueHead.y -= 50;
    blueHead.setScale(blueHead.getScale() * 1.06);
    var redHead = player2.getChildByName("frame_photo02").getChildByName("frame_photo3").getChildByName("photo");
    redHead.setAnchorPoint(cc.p(0.5, 0.5));
    redHead.x += 50;
    redHead.y -= 50;
    redHead.setScale(redHead.getScale() * 1.06);
    cc.log(UserManager.getInstance().profile.headUrl)
    HeadImageLoader.loadImage(blueHead, UserManager.getInstance().profile.headUrl);
    if (enemyAvatar){
        cc.log("enemyAvatar", enemyAvatar)
        HeadImageLoader.loadImage(redHead, enemyAvatar);
    }else if (self.logic){
        cc.log("self.logic.pvpManager.you", self.logic.pvpManager.you);
        HeadImageLoader.loadImage(redHead, self.logic.pvpManager.you.avatar);
    }


    var crownAction = null;
    if (selfResult == 1){
        crownAction = cc.CSLoader.createTimeline("cocos/panel_settlement2_frame_photo01.csb");
        player1.getChildByName("frame_photo01").runAction(crownAction);
    }else if(enemyResult == 1){
        crownAction = cc.CSLoader.createTimeline("cocos/panel_settlement2_frame_photo02.csb");
        player2.getChildByName("frame_photo02").runAction(crownAction);
        winSp.x += 600;
    }else{
        winSp.stopAllActions();
        winSp.setVisible(false);
        winAction = null;
    }

    CfgManager.load("friend_pvp")
    .then((data) => {
        var config = data.get("friend_pvp");
        var winScore = config.pvp_winer_score;
        var loseScore = config.pvp_loser_score;
        var drawScore = config.pvp_draw_score;
        var totalTime = config.pvp_level_effectivetime;
        var txt3 = getText("pvp.settlement.content.time").replace("{time}", selfTime);
        player1Label3.setString(txt3);
        if (selfResult == 1){
            var txt4 = getText("pvp.settlement.content.reward").replace("{points}", winScore);
            player1Label4.setString(txt4);
        }else if (selfResult == 3){
            var txt4 = getText("pvp.settlement.content.reward").replace("{points}", drawScore);
            player1Label4.setString(txt4);
        }else if (selfResult == 5){
            var txt4 = getText("pvp.settlement.content.reward").replace("{points}", 0);
            player1Label4.setString(txt4);
        }else if (selfResult == 6){
            var txt4 = getText("pvp.settlement.content.reward").replace("{points}", 0);
            player1Label4.setString(txt4);
        }else{
            var txt4 = getText("pvp.settlement.content.reward").replace("{points}", loseScore);
            player1Label4.setString(txt4);
        }
        if (enemyResult == 1){
            var txt4 = getText("pvp.settlement.content.reward").replace("{points}", winScore);
            player2Label4.setString(txt4);
        }else if (enemyResult == 3){
            var txt4 = getText("pvp.settlement.content.reward").replace("{points}", drawScore);
            player2Label4.setString(txt4);
        }else if (enemyResult == 5 || enemyResult == 0){
            var txt4 = getText("pvp.settlement.content.reward").replace("{points}", 0);
            player2Label4.setString(txt4);
        }else if (enemyResult == 6){
            var txt4 = getText("pvp.settlement.content.reward").replace("{points}", 0);
            player2Label4.setString(txt4);
        }else{
            var txt4 = getText("pvp.settlement.content.reward").replace("{points}", loseScore);
            player2Label4.setString(txt4);
        }
        CfgManager.release("friend_pvp");
    });

    var replayBtn = self.getChildByName("btn_blue_replay");
    replayBtn.getChildByName("label").setString(getText("pvp.settlement.repeat1"));
    replayBtn.getChildByName("label").x += 8;

    var shareBtn = self.getChildByName("btn_green_showoff");
    quickBuildUIBUtton(replayBtn, () => {
        if (self.logic){
            self.logic.finishGame();
            DCAssist.userTrack("PVP", "click_restart_btn", {"abtest":"new"});
            self.dispatchEvent({name : WinPanelEvent.Close});
        }else{
            self.onClose();
        }
    })
    shareBtn.getChildByName("label").setString(getText("pvp.settlement.repeat2"));
    shareBtn.getChildByName("label").x += 8;

    if (isFromStandingPanel){
        // 战报进来的没有动画
        player1Label1.setOpacity(255);
        player1Label2.setOpacity(255);
        player1Label3.setOpacity(255);
        player1Label4.setOpacity(255);
        player2Label1.setOpacity(255);
        player2Label2.setOpacity(255);
        player2Label3.setOpacity(255);
        player2Label4.setOpacity(255);

        if (winAction){
            winAction.gotoFrameAndPlay(1, 63, false);
        }
        if (crownAction){
            crownAction.gotoFrameAndPlay(1, 63, false);
        }

        shareBtn.getChildByName("label").setString(getText("pvp.battle.reportbutton02"));
        shareBtn.getChildByName("label").x += 40;
        shareBtn.x = (replayBtn.x+shareBtn.x)/2;
        replayBtn.setVisible(false);
        quickBuildUIBUtton(shareBtn, () => {
            self.onClose();
        })
    }else{
        replayBtn.setOpacity(0);
        shareBtn.setOpacity(0);

        var showTxt1 = function(){
            player1Label1.runAction(cc.fadeIn(1));
            player2Label1.runAction(cc.fadeIn(1));
        }
        var showTxt2 = function(){
            player1Label2.runAction(cc.fadeIn(1));
            player2Label2.runAction(cc.fadeIn(1));
        }
        var showTxt3 = function(){
            player1Label3.runAction(cc.fadeIn(1));
            player2Label3.runAction(cc.fadeIn(1));
        }
        var showTxt4 = function(){
            player1Label4.runAction(cc.fadeIn(1));
            player2Label4.runAction(cc.fadeIn(1));
            if (winAction){
                winAction.gotoFrameAndPlay(1, 63, false);
            }
            if (crownAction){
                crownAction.gotoFrameAndPlay(1, 63, false);
            }
            replayBtn.runAction(cc.fadeIn(1));
            shareBtn.runAction(cc.fadeIn(1));
        }
        var a1 = cc.delayTime(0.5);
        var a2 = cc.callFunc(showTxt1);
        var a3 = cc.delayTime(1.5);
        var a4 = cc.callFunc(showTxt2);
        var a5 = cc.delayTime(1.5);
        var a6 = cc.callFunc(showTxt3);
        var a7 = cc.delayTime(1.5);
        var a8 = cc.callFunc(showTxt4);

        self.runAction(cc.sequence(a1, a2, a3, a4, a5, a6, a7, a8));
        
        if (selfResult == 1){
            quickBuildUIBUtton(shareBtn, () => {
                ShareUtil.clickPvpNewShowOff(pvplogic.pvpManager.you.name);
            })
            DCAssist.dc4ShareShow("pvp_new_showoff");
        }else{
            replayBtn.setVisible(true);
            shareBtn.setVisible(false);
            replayBtn.x = (replayBtn.x+shareBtn.x)/2;
        }
    }
}

PvpActivityResultPanel.prototype.onCleanup = function() {
    ResManager.release(["packed/PvpSettlement2Res.pack"]);
}

PvpActivityResultPanel.prototype.popup = function () {
    var self = this
    var targetScale = self.getScale()
    self.setScale(0)
    var time = 7 / 30
    PopoutManager.getInstance().addWithBgFadeIn(self, true, false)
    var vSize = cc.Director.getInstance().getVisibleSize();
    var dH = display.height-GamePlayConfig_Design_Height;
    var targetPos = cc.pAdd(cc.p(self.getPosition()), cc.p(-100, 900 + dH/2));
    var pos_O = cc.p(vSize.width / 2, vSize.height / 2)
    var startPoint = cc.pMul(cc.pSub(targetPos, pos_O), 0.23)
    self.setScale(0.23)
    self.setPosition(cc.p(pos_O.x + startPoint.x, pos_O.y + startPoint.y))
    self.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(time, targetScale), cc.MoveTo.create(time, targetPos)))))
    return self
}

module.exports = PvpActivityResultPanel